<template>
	<div style="height: 100%">
		<div class="cumtomerGroup">
			<div class="dPleft">

				<div class="dPleftTab">
					<div v-if="sfkg==false" class="dPleftTabul">
						<div v-for="(item, index) in tabListone" :key="index">
							<div class="dPleftTabulItem" :class="{ navSpan: index == tabIndex }"
								@click="tabClick(item, index)">
								<img v-if="item.img !== ''&&index!==0" style="margin-left: 10px;"
									:src="index == tabIndex ? item.image : item.img" class="navImg" alt="" />
								<img v-if="item.img !== ''&&index==0" :src="index == tabIndex ? item.image : item.img"
									class="navImg" alt="" />
								<span v-if="item.img !== ''">{{ item.label }}</span>
								<span class="dPleftTIRb" v-else>{{ item.label }}</span>
							</div>
						</div>
					</div>
					<div v-else class="dPleftTabul">
						<div v-for="(item, index) in tabList" :key="index">
							<div class="dPleftTabulItem" :class="{ navSpan: index == tabIndex }"
								@click="tabClick(item, index)">
								<img v-if="item.img !== ''&&index!==0" style="margin-left: 10px;"
									:src="index == tabIndex ? item.image : item.img" class="navImg" alt="" />
								<img v-if="item.img !== ''&&index==0" :src="index == tabIndex ? item.image : item.img"
									class="navImg" alt="" />
								<span v-if="item.img !== ''">{{ item.label }}</span>
								<span class="dPleftTIRb" v-else>{{ item.label }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="dPRight">
				<!-- <div class="mainTop">
					<div class="mainTopTitle">消息提醒</div>
					<span class="el-icon-close"></span>
				</div> -->
				<div class="mainTop">
					<!-- <div>全部</div> -->
					<div>
						{{tabList[tabIndex].label}}
						<div class="header-con-form-item" style="display: inline-block;margin-left: 10px;margin-right: 10px;">
							<div class="sousuomingcheng" style="display: inline-block;">起始日期:</div>
							<el-date-picker v-model="kaishishijian" @change="systemUser()" style="width: 200px;display: inline-block;margin-left: 10px;"
								type="date" range-separator="至" value-format="yyyy-MM-dd"
								start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
						<div class="header-con-form-item" style="display: inline-block;margin-left: 10px;margin-right: 10px;">
							<div class="sousuomingcheng" style="display: inline-block;">终止日期:</div>
							<el-date-picker v-model="jieshushijian"  @change="systemUser()" style="width: 200px;display: inline-block;margin-left: 10px;"
								type="date" range-separator="至" value-format="yyyy-MM-dd"
								start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
						<el-button @click="formDialog = true" type="primary" v-if="jueseID == 12">新建留言</el-button>

					</div>

				</div>
				<div class="main">
					<el-scrollbar class="mainInfoList">
						<div class="mainInfoListInfo" v-for="(item,index) in infoList" :key="index">
							<div is-dot style="width: 100%;">
								<div class="mainInfoLtitle">

									<span class="mainInfoLtitleLetf" style="color: #3B86FF;">{{item.CUSTOMER_NAME}}</span>
								</div>
								<div class="mainInfoLCent" style="color: #000000;">{{item.CONTENT}}</div>

								<div class="mainInfoBottom">

									<div class="mainInfoLCent">

										<div class="mainInfoLCent" style="display: inline-block;">{{item.CREATED_TIME}}
										</div>
										<div style="display: inline-block;" v-if="item.TYPE==1">
											
											<div style="display: inline-block;margin-left: 20px;margin-right: 5px;color: #3B86FF;">褒奖</div>
											<div style="display: inline-block;vertical-align: top;">
												<img src="@/assets/img/baojiang.png" class="navImg" alt="" />
											</div>

										</div>
										<div style="display: inline-block;" v-if="item.TYPE==2">
											
											<div style="display: inline-block;margin-left: 20px;margin-right: 5px;color: #3B86FF;">投诉</div>
											<div style="display: inline-block;vertical-align: top;">
												<img src="@/assets/img/tousu.png" class="navImg" alt="" />
											</div>

										</div>

									</div>
									<!-- <div class="mainInfoLtitleRight">{{item.CREATED_TIME}}</div> -->
								</div>

							</div>

						</div>
					</el-scrollbar>
					<!-- <el-empty v-else description="暂无消息"></el-empty> -->
				</div>
				<div class="headflood" style="justify-content: flex-end">
					<pagination :allPage="total" :pageCount="5" :pageSize="pageSize" :currIndex="pageIndex"
						@hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange">
					</pagination>
				</div>
			</div>



		</div>
		<el-dialog title="留言" :visible.sync="formDialog" width="800px">
			<div class="dialog-con">
				<el-col :span="24">
					<el-form class="header-con-form" :inline="true">
						<div class="headerpingjia">
							选择留言类型！
						</div>
					</el-form>
					<!-- <div class="taiyangImage">
						<img src="~assets/img/xiaolian.png" class="taiyangImagez">
					</div> -->
					<div class="headerfueuxingji">
						<div style="display: inline-block;" @click="XuanZeBJTS(1)">
							<img v-if="cztype==1" src="~assets/img/xinjianbaojiang.png" class="taiyangImagez">
							<img v-else src="~assets/img/xinjiangbaojiangxu.png" class="taiyangImagez">
							<div style="text-align: center;margin-bottom: 10px;">褒奖</div>
							<!-- 服务星级： -->
						</div>
						<div style="display: inline-block;margin-left: 50px;"  @click="XuanZeBJTS(2)">
							<img v-if="cztype==2" src="~assets/img/xinjiantousu.png" class="taiyangImagez">
							<img v-else src="~assets/img/xinjiantousuxu.png" class="taiyangImagez">
							<!-- 服务星级： -->
							<div style="text-align: center;margin-bottom: 10px;">投诉</div>
						</div>


					</div>
					<div class="headermiaoshu">
						<el-form class="header-con-form" :inline="true">

							<!-- <div class="fuwuxingjiwza">
								留言板：
							</div> -->
							<el-input class="form-item-input" type="textarea" :rows="8" placeholder="请输入留言内容"
								v-model="miaoshu">
							</el-input>

						</el-form>
					</div>

				</el-col>
			</div>
			<div slot="footer">
				<el-button type="primary" @click="tijiaopingjia()" :disabled="isTiJiao">提交</el-button>

			</div>
		</el-dialog>

	</div>

</template>
<script>
	export default {
		name: "LiuYan",
		inject: ['reload'],
		data() {
			return {
				kaishishijian:"",
				jieshushijian:"",
				cztype:1,
				jueseID: JSON.parse(localStorage.getItem("userInfo")).ROLE,
				isTiJiao: false,
				Type: "",
				SearchStr: "",
				miaoshu: "",
				formDialog: false,
				sfkg: false,
				pageIndex: 1, //单页数量
				pageSize: 10, //单页数量
				tabList: [{
						label: "全部",
						img: require("@/assets/img/quanbuliuyan.png"),
						image: require("@/assets/img/quanbuliuyan.png"),
						id: 1,
					},
					{
						label: "褒奖",
						img: require("@/assets/img/baojiang.png"),
						image: require("@/assets/img/baojiang.png"),
					},
					{
						label: "投诉",
						img: require("@/assets/img/tousu.png"),
						image: require("@/assets/img/tousu.png"),
					}
				],
				tabListone: [{
					label: "全部",
					img: require("@/assets/img/quanbuliuyan.png"),
					image: require("@/assets/img/quanbuliuyan.png"),
					id: 1,
				}],
				StartTime: "",
				EndTime: "",
				BaseCreateName: "",
				SumModule: false,
				command: 0,
				opTelType: "",
				showObject: {},
				newMaketLits: {}, //全部商机详情
				showDialog: false, // 是否显示弹窗
				tabIndex: 0,
				AtJson: [],
				infoListrz: [{
						name: "接收范围",
						value: "",
						label: "",
					},
					{
						name: "已读",
						value: 0,
						label: 1,
					},
					{
						name: "未读",
						value: 1,
						label: 0,
					},
				],

				dialogVisible: false,
				weiIndex: 0,
				infoDate: [],
				infoIndex: 0,
				MemberNameTeax: "",
				MemberNameUser: "",
				weiList: [{
						label: "已读",
						num: 1,
						value: 1,
					},
					{
						label: "未读",
						num: 0,
						value: 0,
					},
				],
				Imags: [],


				isSP: true,
				SFRL: true,
				infoList: [],
				infoListwd: [],
				total: 0,

			};
		},
		// created() {},
		destroyed() {
			localStorage.removeItem("addType"); //组件卸载清除类型缓存
		},
		activated() {
			this.systemUser()
		},
		mounted() {
			this.systemUser()
		},
		methods: {
			XuanZeBJTS(row){
				this.cztype=row;
			},
			//提交评价
			tijiaopingjia() {
				this.isTiJiao = true;
				let data = {

					CONTENT: this.miaoshu, //服务评价
					TYPE: this.cztype, //留言类型：1褒奖、2投诉

				};
				// this.formDialog = true;

				this.scoped = true;

				this.$request({
						method: "post",
						url: "Guestbook/Add",
						data: data,
					})
					.then(() => {
						this.isTiJiao = false;
						this.$message({
							message: "发起成功！",
							type: "success",
						});

						this.miaoshu = '';
						this.xingji = 5;
						this.formDialog = false;
						this.systemUser()

					})
					.catch((err) => {
						this.isTiJiao = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},

			tabClick(item, row) {
				console.log(item, row)
				this.tabIndex = row;
				if(row==0){
					this.Type="";
				}else{
					this.Type=row;
				}
				
				if (row == 0) {
					if (this.sfkg == false) {
						this.sfkg = true;
					} else {
						this.sfkg = false;
					}

				}
				this.systemUser();
			},

			looKDetails(item) {
				console.log(item)
			},

			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.pageIndex = 1;
				this.systemUser();
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.pageIndex = val;
				this.systemUser();
			},
			systemUser() {
				this.$request({
						method: "get",
						url: "/Guestbook/GetPageList?SearchStr=" + encodeURIComponent(this.SearchStr) +
							"&StartTime=" + encodeURIComponent(this
								.kaishishijian)+ "&EndTime="+ encodeURIComponent(this
								.jieshushijian) + "&Type=" + encodeURIComponent(this
								.Type) +
							"&pageIndex=" + encodeURIComponent(this
								.pageIndex) + "&pageSize=" + encodeURIComponent(this
								.pageSize),
					})
					.then((res) => {
						this.infoList = []

						if (res.Code == "0") {

							// for (var i in res.Data) {
							// 	//console.log(res.Data[i].AddTime)
							// 	let date1Str = res.Data[i].AddTime.split("T").join(" "); //将日期字符串分隔为数组,数组元素分别为年.月.日

							// 	this.$set(res.Data[i], 'AddTimea', date1Str);
							// }
							this.infoList = res.Data
							console.log("this.infoList.length", this.infoList.length);

							// this.reload()
						}
						this.total = res.Total;
					})
					.catch((err) => {
						console.log(err);
					});
			},

		},
	};
</script>
<style lang="scss" scoped>
	.main {
		background: #f4f4f4;
		height: calc(100vh - 220px);
		overflow: auto;

	}

	.cumtomerGroup {
		box-sizing: border-box;
		width: 100%;
		// height: 100%;
		height: calc(100vh - 60px);
		padding: 0 10px;
		background-color: #f6f8fa;
		display: flex;
		overflow: hidden;

		.dPleft {
			margin-top: 0px;
			flex: 0 0 15%;
			padding: 20px 15px;

			.dPleftTitle {
				.dPleftTbt {
					font-size: 18px;
					font-weight: 550;
					margin-bottom: 10px;
					color: #000;
				}

				.dPleftTgs {
					color: #000;
					font-size: 14px;
					margin-bottom: 20px;
				}

				.dPleftTgsButt {
					width: 100%;
				}
			}

			.dPleftTab {
				margin-top: 0px;

				.dPleftTabul {
					.dPleftTabulItem {
						padding: 10px 15px;
						display: flex;
						align-items: center;
						cursor: pointer;

						img {
							width: 20px;
							height: 20px;
							margin-right: 12px;
						}

						span {
							font-size: 14px;
						}

						.dPleftTIRb {
							padding-left: 30px;
						}
					}

					.dPleftTabulItem:nth-child(5)::after {
						border-top: 1px solid #e2e4e6;
						margin: 20px 0 0;
					}
				}

				.navSpan {
					color: #3b86ff;
					background: #e0eaf8;
					border-radius: 10px;
				}
			}
		}

		.navSpan {
			color: #3b86ff;
			background: #e0eaf8;
			border-radius: 10px;
		}

		.dPRight {
			flex: 0 0 83%;
			background: #fff;
			margin-top: 0px;

			.dPRightWd {
				.dPRightWdTitle {
					position: fixed;
					width: 74%;
					background: #fff;
					padding: 7px 20px;
					z-index: 3;
					display: flex;
					align-items: center;
					justify-content: space-between;
					box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);

					.dPRightWdTLeft {
						display: flex;
						align-items: center;
						font-size: 15px;
						font-weight: 550;

						.dPRightWdTLHx {
							display: inline-block;
							padding: 0 20px;
							font-weight: 200;
							color: #eaebed;
						}
					}
				}

				.dPRightWdCenter {
					display: flex;
					padding-top: 45px;

					.dPRightWdCeLeft {
						// flex: 0 0 25%;
						width: 280px;
						height: 100%;

						.dPRWdCeLItem {
							padding: 0px 10px;

							.dPRWdCeLItemTitle {
								font-size: 15px;
								color: #a2a3a5;
								padding-bottom: 5px;
							}

							.dPRWdCeLItemCent {
								display: flex;
								justify-content: space-between;
								align-items: center;
								padding: 8px 8px;
								cursor: pointer;

								.dPRWdCeLItemCeHad {
									display: flex;
									justify-content: space-between;
									align-items: center;

									img {
										width: 25px;
										height: 25px;
										margin-right: 18px;
										border-radius: 6px;
									}

									span {
										font-size: 14px;
										color: #121f2c;
									}
								}

								.dPRWdCeLItemCeyd {
									display: inline-block;
									font-size: 12px;
									color: #a3a4a6;
									border: 1px solid #a2a3a4;
									padding: 2px 4px;
									border-radius: 4px;
								}
							}

							.dPRWdCeLItemCent:hover {
								background: #eff0f2 !important;
								border-radius: 10px;
							}

							.active {
								background: #e8f1fe !important;
								border-radius: 10px;
							}
						}
					}

					.dPRightWdCeright {
						// flex: 0 0 75%;
						width: calc(100% - 250px);
						padding: 40px 0;
						border-left: 1px solid #ecedee;

						i {
							color: #9e99a1;
							cursor: pointer;
						}

						.dPRightWdCerCen {
							display: flex;
							justify-content: space-between;
							margin-bottom: 46px;

							.dPRightWdCerCenHead {
								display: flex;

								img {
									width: 40px;
									height: 40px;
									border-radius: 4px;
									margin-right: 15px;
								}

								.dPRightWdCerCenHTi {
									.dPRtWdCCHRb {
										font-size: 18px;
										color: #000;
										font-weight: 550;
									}

									.dPRtWdCCHt {
										margin-top: 5px;

										.dPRtWdCCHtI {
											font-size: 12px;
											color: #9e99a1;
										}

										.dPRtWdCCRzJ {
											display: inline-block;
											margin-left: 12px;
											color: #3b86ff;
											font-size: 12px;
											cursor: pointer;
										}
									}
								}
							}
						}

						.dPRightWdCerCDay {
							font-size: 14px;
							color: #191f25;
							margin-bottom: 30px;
							white-space: pre-wrap; //保留所有空格

							.dPproces {
								width: 24px;
								height: 24px;

								.el-progress-circle {
									width: 24px !important;
									height: 24px !important;
								}
							}

							.dPRightWdCerCDayWork {
								width: 100%;
								font-size: 14px;
								color: #404040;
								font-weight: 550;
								margin-bottom: 10px;
							}
						}

						.dPRightWdCerCDayInpu {
							display: flex;
							align-items: center;

							// .input {
							// 	width: 80%;
							// }
							.editor {
								margin: 0 auto;
								background-color: aqua;
								width: 80%;
								height: 30px;
								background: #fff;
								border: 1px solid blue;
								border-radius: 5px;
								text-align: left;
								padding: 10px;
								overflow: auto;
								line-height: 30px;

								&:focus {
									outline: none;
								}
							}

							.inputdz {
								margin-left: 10px;
								width: 25px;
								height: 25px;
								cursor: pointer;
							}

							.inputdzDZ {
								display: inline-block;
								margin-left: 10px;
								color: #3b86ff;
								font-size: 12px;
								cursor: pointer;
							}
						}
					}
				}

				.dPRightWdCentera {
					display: flex;
					padding-top: 0px;

					.dPRightWdCeLeft {
						// flex: 0 0 25%;
						width: 280px;
						height: 100%;

						.dPRWdCeLItem {
							padding: 0px 10px;

							.dPRWdCeLItemTitle {
								font-size: 15px;
								color: #a2a3a5;
								padding-bottom: 5px;
							}

							.dPRWdCeLItemCent {
								display: flex;
								justify-content: space-between;
								align-items: center;
								padding: 8px 8px;
								cursor: pointer;

								.dPRWdCeLItemCeHad {
									display: flex;
									justify-content: space-between;
									align-items: center;

									img {
										width: 25px;
										height: 25px;
										margin-right: 18px;
										border-radius: 6px;
									}

									span {
										font-size: 14px;
										color: #121f2c;
									}
								}

								.dPRWdCeLItemCeyd {
									display: inline-block;
									font-size: 12px;
									color: #a3a4a6;
									border: 1px solid #a2a3a4;
									padding: 2px 4px;
									border-radius: 4px;
								}
							}

							.dPRWdCeLItemCent:hover {
								background: #eff0f2 !important;
								border-radius: 10px;
							}

							.active {
								background: #e8f1fe !important;
								border-radius: 10px;
							}
						}
					}

					.dPRightWdCeright {
						// flex: 0 0 75%;
						width: calc(100% - 250px);
						padding: 40px 0;
						border-left: 1px solid #ecedee;

						i {
							color: #9e99a1;
							cursor: pointer;
						}

						.dPRightWdCerCen {
							display: flex;
							justify-content: space-between;
							margin-bottom: 46px;

							.dPRightWdCerCenHead {
								display: flex;

								img {
									width: 40px;
									height: 40px;
									border-radius: 4px;
									margin-right: 15px;
								}

								.dPRightWdCerCenHTi {
									.dPRtWdCCHRb {
										font-size: 18px;
										color: #000;
										font-weight: 550;
									}

									.dPRtWdCCHt {
										margin-top: 5px;

										.dPRtWdCCHtI {
											font-size: 12px;
											color: #9e99a1;
										}

										.dPRtWdCCRzJ {
											display: inline-block;
											margin-left: 12px;
											color: #3b86ff;
											font-size: 12px;
											cursor: pointer;
										}
									}
								}
							}
						}

						.dPRightWdCerCDay {
							font-size: 14px;
							color: #191f25;
							margin-bottom: 30px;
							white-space: pre-wrap; //保留所有空格

							.dPproces {
								width: 24px;
								height: 24px;

								.el-progress-circle {
									width: 24px !important;
									height: 24px !important;
								}
							}

							.dPRightWdCerCDayWork {
								width: 100%;
								font-size: 14px;
								color: #404040;
								font-weight: 550;
								margin-bottom: 10px;
							}
						}

						.dPRightWdCerCDayInpu {
							display: flex;
							align-items: center;

							// .input {
							// 	width: 80%;
							// }
							.editor {
								margin: 0 auto;
								background-color: aqua;
								width: 80%;
								height: 30px;
								background: #fff;
								border: 1px solid blue;
								border-radius: 5px;
								text-align: left;
								padding: 10px;
								overflow: auto;
								line-height: 30px;

								&:focus {
									outline: none;
								}
							}

							.inputdz {
								margin-left: 10px;
								width: 25px;
								height: 25px;
								cursor: pointer;
							}

							.inputdzDZ {
								display: inline-block;
								margin-left: 10px;
								color: #3b86ff;
								font-size: 12px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}

	.mainTop {
		padding: 15px 15px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 2px solid #ebedf0;
		background: #fff;
		font-size: 16px;

		.mainTopTitle {
			font-weight: 550;
		}
	}

	.mainInfoList {
		padding: 18px 20px;
		overflow: auto;

		.mainInfoListInfo {
			background: #ffffff;
			opacity: 1;
			border-radius: 6px;
			padding: 20px;
			margin-bottom: 20px;

			.mainInfoLtitle {
				font-size: 14px;
				display: flex;
				justify-content: space-between;
				padding-bottom: 20px;
				border-bottom: 1px solid #ECEDEE;

				.mainInfoLtitleLetf {
					// color: #3B86FF;
					color: #000;
					font-weight: 550;
					cursor: pointer;
				}

				.mainInfoLtitleRight {
					color: #666666;
				}
			}

			.mainInfoLCent {
				padding: 10px 0;
				font-size: 15px;
				// color: #000;
				color: #666666;
			}

			.mainInfoBottom {
				display: flex;
				justify-content: space-between;
				font-size: 12px;
				color: #fff;
			}
		}
	}

	// 统计详情
	.drawer {
		.drawerTitle {
			width: 100%;
			padding: 30px 25px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.drawerTitlRb {
				color: #000;
				font-size: 15px;
			}

			span {
				cursor: pointer;
				font-size: 18px;
				color: #999;
			}
		}

		.drawerCenter {
			.drawerCeYes {
				width: 100%;
				text-align: center;
				font-size: 14px;
				color: #000;

				span {
					display: inline-block;
					width: 20px;
					height: 16px;
					border-radius: 2px;
					border: 1px solid #999;
					color: #999;
					font-size: 12px;
					text-align: center;
					line-height: 16px;
					margin-left: 10px;
					cursor: pointer;
				}
			}

			.drawerCeAsTj {
				margin-top: 25px;
				text-align: center;

				.el-radio-button--small .el-radio-button__inner {
					padding: 9px 38px !important;
				}
			}

			.drawerCeAsCen {
				padding: 20px 25px;

				.drawerCeAsCenItem {
					display: flex;
					align-items: center;

					img {
						width: 35px;
						height: 35px;
						border-radius: 4px;
					}

					.drawerCeAsCenItemLZ {
						width: 100%;
						padding: 20px 0;
						margin-left: 20px;
						border-bottom: 1px solid #f1f1f1;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.BaseCr {
							font-size: 14px;
							color: #999;
						}

						.drawerCeAsCenItemLZname {
							font-size: 15px;
							color: #333333;
							font-weight: 550;
						}

						.drawerCeAsCenItemLZerp {
							margin-top: 10px;
							font-size: 12px;
							color: #7e8185;
						}
					}
				}
			}

			.drawerCeAsCenBott {
				font-size: 12px;
				color: #a0a2a5;
				text-align: center;
			}
		}
	}

	// 评论日报详情
	.dayDetCen {
		.dayDetCenTitle {
			padding: 0 30px;
			display: flex;
			align-items: center;

			img {
				width: 40px;
				height: 40px;
				border-radius: 4px;
			}

			.dayDetCenTitleNe {
				margin-left: 15px;
				font-size: 14px;
				color: #333333;
				font-weight: bold;

				.dayDetCenTitleNeTime {
					margin-top: 5px;
					color: #9e99a1;
					font-weight: 500;
					font-size: 12px;
				}
			}
		}

		.dayDetCenDayWork {
			padding: 0 30px;
			margin-top: 30px;
			font-size: 14px;

			.dayDetCenDay {
				font-weight: 550;
			}

			.dayDetCenwork {
				margin-top: 15px;
			}
		}

		.dayDetCenDayWj {
			padding: 15px 30px;
			border-top: 1px solid#F1F1F1;
			border-bottom: 1px solid#F1F1F1;
			display: flex;
			align-items: center;

			img {
				width: 40px;
				height: 40px;
			}

			.dayDetCenDayWjname {
				margin-left: 10px;
				font-size: 14px;
				font-weight: 550;

				.dayDetCenDayWjnamedx {
					margin-top: 5px;
					color: #7d8082;
					font-weight: 500;
				}
			}
		}

		.dayDetCenTj {
			padding: 0 30px;

			.dayDetCenTjTile {
				font-size: 14px;
				padding: 15px 0;
				color: #000;
			}

			.dayDetCenTjCen {
				display: flex;
				flex-wrap: wrap;

				.dayDetCenTjCenRb {
					flex: 0 0 40%;
					padding: 16px;
					border: 1px solid #ededee;
					display: flex;
					align-items: center;
					margin-right: 20px;
					margin-bottom: 16px;

					img {
						width: 30px;
						height: 30px;
					}

					.dayDetCenTjCenRbNa {
						margin-left: 20px;

						.dayDetCenTjCenRbTitle {
							font-size: 14px;
							font-weight: 550;
						}

						.dayDetCenTjCenRbTRZ {
							font-size: 14px;
						}

						.dayDetCenTjCenRbDay {
							margin-top: 10px;
							color: #a3a4a6;
							font-size: 12px;

							.dayDetCenRq {
								width: 100px;
							}

							.dayDetCenWd {
								display: inline-block;
								margin-left: 10px;
								padding: 2px 6px;
								background: #576a94;
								border-radius: 4px;
								color: #fff;
								font-size: 12px;
							}
						}
					}
				}

				.dayDetCenTjCenRb:nth-child(2n) {
					margin-right: 0px;
				}
			}
		}

		.dayDetCenDzr {
			padding: 20px 30px;
			border-top: 1px solid #ededee;
			display: flex;
			align-items: center;

			img {
				width: 15px;
				height: 15px;
				margin-right: 10px;
			}

			span {
				font-size: 12px;
				color: #576a94;
			}
		}

		.dayDetCenDZTsf {
			padding: 0 30px 20px 30px;
			font-size: 14px;
			border-bottom: 1px solid #ededee;

			.dayDetCenDZTsfSpan {
				display: flex;
				justify-content: space-between;

				.dayWei {
					span {
						display: inline-block;
						margin-right: 82px;
						cursor: pointer;
					}
				}

				.dayCk {
					cursor: pointer;
					font-size: 12px;
					color: #a3a4a6;
				}
			}
		}

		.dayDetCenDZImg {
			padding: 20px 30px;
			display: flex;
			flex-wrap: wrap;

			.dayDetCenDZLength {
				display: flex;
				align-items: flex-start;
			}

			p {
				width: 50px;
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
				margin-right: 10px;

				img {
					width: 30px;
					height: 30px;
					border-radius: 4px;
				}

				.name {
					display: inline-block;
					margin-top: 10px;
					width: 100%;
					text-align: center;
					font-size: 12px;
					color: #191f25;
				}
			}
		}

		.dayDetCenDZWpl {
			padding: 20px 30px;
			color: #7d8082;
			font-size: 14px;
			border-bottom: 1px solid #f1f1f1;

			.dayPl {
				color: #191f25;
				font-size: 15px;
			}

			.dayPlList {
				display: flex;
				margin-top: 10px;

				img {
					width: 30px;
					height: 30px;
					border-radius: 4px;
					margin-right: 16px;
				}

				.dayPlListItem {
					.dayPlListItemName {
						font-size: 14px;
						color: #a2a3a5;
					}

					.dayPlListItemNR {
						margin-top: 9px;
						font-size: 16px;
						color: #000;
					}

					.dayPlListItemTime {
						margin-top: 9px;
						font-size: 14px;
						color: #a2a3a5;

						span {
							display: inline-block;
							margin-right: 10px;
							cursor: pointer;
						}
					}
				}
			}
		}

		.dayDetCenDZWQpl {
			display: flex;
			align-items: center;
			padding: 20px 30px;

			span {
				font-size: 12px;
				color: #3b86ff;
			}

			.input {
				width: 80%;
			}

			.inputdz {
				margin-left: 20px;
				width: 20px;
				height: 20px;
				cursor: pointer;
			}
		}

		.weiSpan {
			color: #3b86ff;
		}
	}

	.info {
		.infoList {
			.infoTitle {
				position: absolute;
				background: #fff;
				width: 100%;
				top: 0px;

				div {
					display: flex;
					justify-content: space-between;
					align-items: center;

					span {
						font-size: 16px;
						margin-right: 20px;
						cursor: pointer;
					}
				}

				p {
					padding: 20px 20px 13px;
					cursor: pointer;
				}

				.infoActive {
					border-bottom: 1px solid #3b86ff !important;
					color: #3b86ff !important;
				}
			}

			.infoCenter {
				height: 400px;
				background: #e8e8e8;
				padding-top: 35px;

				.infoCeTitle {
					background: #fff;
					color: #848185;
					font-size: 14px;
					padding: 0 20px;

					p {
						padding: 14px 0;
						border-bottom: 1px solid #e8e8e8;
					}

					.infoCeHaad {
						display: flex;
						align-items: center;

						img {
							width: 35px;
							height: 35px;
							border-radius: 6px;
						}

						p {
							margin-left: 16px;
							padding: 25px 0;
							border-bottom: 1px solid #e8e8e8;
							width: 90%;
							color: #262626;
						}
					}
				}
			}

			.infoCenter1 {
				height: 400px;
				background: #e8e8e8;
				padding-top: 40px;

				.infoWdWH {
					display: flex;
					background: #fff;
					height: 360px;
					padding: 20px 20px;

					.infoWd {
						width: 45px;
						height: 50px;
						margin-right: 20px;
						display: flex;
						flex-wrap: wrap;
						justify-content: center;

						img {
							width: 30px;
							height: 30px;
							border-radius: 4px;
						}

						.nbeds {
							display: inline-block;
							margin-top: 5px;
							text-align: center;
							width: 45px;
						}
					}
				}
			}
		}
	}

	.tux3 {
		display: inline-block;
		width: 30px;
		height: 30px;
		border-radius: 4px;
		color: #fff !important;
		background-color: #409eff;
		text-align: center;
		line-height: 30px;
		font-size: 12px;
	}

	.tux {
		display: inline-block;
		width: 40px;
		height: 40px;
		border-radius: 4px;
		margin-right: 15px;
		color: #fff;
		background-color: #409eff;
		text-align: center;
		line-height: 40px;
		font-size: 14px;
	}

	.tux1 {
		display: inline-block;
		width: 25px;
		height: 25px;
		border-radius: 4px;
		margin-right: 15px;
		color: #fff !important;
		background-color: #409eff;
		text-align: center;
		line-height: 25px;
		font-size: 12px;
	}

	.dayDetCenDZWQpl {
		display: flex;
		align-items: center;
		padding: 20px 30px;

		span {
			font-size: 12px;
			color: #3b86ff;
		}

		.input {
			width: 80%;
		}

		.editor {
			margin: 0 auto;
			background-color: aqua;
			width: 80%;
			height: 30px;
			background: #fff;
			border: 1px solid blue;
			border-radius: 5px;
			text-align: left;
			padding: 10px;
			overflow: auto;
			line-height: 30px;

			&:focus {
				outline: none;
			}
		}

		.inputdz {
			margin-left: 20px;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}

		.dayDetCenScrollbar {
			overflow: auto;
			height: calc(100vh - 60px);
			padding-bottom: 40px;
			cursor: pointer;
		}
	}

	/**dialog中样式 */
	.dialog-con {
		height: 375px;
		overflow: auto;
	}

	/**dialog中样式 */
	.dialog-cona {
		height: auto;
		overflow: auto;
	}

	.header-con-form {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		word-wrap: break-word;
		overflow: hidden;
		margin: auto
			/* 看自己需要设置，不影响div高度变化*/
	}

	.headerpingjia {
		margin-bottom: 0;
		text-align: center;
		width: 100%;
		font-size: 20px;

	}

	.taiyangImage {

		display: flex;
		justify-content: center;
		align-items: center;
	}

	.headerfueuxingji {
		margin-bottom: 0;
		margin-top: 0;
		margin-left: 36%;
		width: 50%;
		font-size: 16px;
		color: #666666;
	}

	.fuwuxingjiwz {
		height: 40px;
		line-height: 60px;
	}

	.fuwuxingjiwza {
		height: 140px;
		margin-top: -20px;
		font-size: 16px;
	}

	// /**输入框宽度 */
	// .form-item-input {
	// 	width: 450px;
	// }

	/**底部分页 */
	.footer {
		height: 50px;
		margin-right: 0px;
	}

	.taiyangImagez {
		margin: 10px;
		width: 60px;
		height: 60px;
	}
</style>